export default __webpack_public_path__ + "static/media/arrow_5.a94d5e9e.svg";